import React from 'react';
import { useI18n } from '../i18n/LanguageContext';

const CONTENT = {
  ro: {
    title: 'Politica de confidentialitate',
    lead:
      'Aceasta pagina explica ce date pot fi prelucrate prin acest site, in ce scop si cum sunt gestionate. Textul trebuie revizuit periodic impreuna cu persoana sau consultantul responsabil de conformitate juridica.',
    sections: [
      {
        title: 'Operator si date de contact',
        paragraphs: [
          'Site-ul este operat de YOUNGER KAROM PRODUCTION COMPANY SRL, CUI 4219179, inregistrata la Registrul Comertului sub nr. J40/15256/1993. Pentru solicitari privind confidentialitatea datelor sau exercitarea drepturilor tale, ne poti contacta la office@youngerkarom.ro sau la adresa Strada Paharnicul Turturea 12, Sector 2, Bucuresti, Romania.',
        ],
      },
      {
        title: 'Ce date pot fi colectate',
        paragraphs: [
          'Cand folosesti formularul de contact, putem prelucra numele, compania, telefonul, adresa de email si mesajul transmis de tine.',
          'Site-ul foloseste si date tehnice strict necesare pentru functionare, cum ar fi preferinta de limba si alegerea privind cookies, stocate local in browser.',
          'Date de analiza a utilizarii site-ului sunt colectate numai daca iti dai consimtamantul pentru cookies analitice.',
        ],
      },
      {
        title: 'Temeiuri si scopuri',
        paragraphs: [
          'Datele din formularul de contact sunt folosite pentru a raspunde solicitarilor tale comerciale sau tehnice si pentru a continua conversatia ceruta de tine.',
          'Stocarea preferintelor tehnice necesare se face pentru functionarea corecta a site-ului si pentru memorarea optiunilor tale.',
          'Analytics optionale sunt folosite doar dupa consimtamant, pentru a intelege utilizarea site-ului, a imbunatati continutul si a identifica eventuale probleme de experienta.',
        ],
      },
      {
        title: 'Servicii terte',
        paragraphs: [
          'Pentru functionarea formularului de contact pot fi implicati furnizori tehnici care proceseaza datele strict necesare trimiterii mesajului.',
          'Daca accepti cookies analitice, un furnizor tert de analytics poate prelucra informatii despre interactiunea cu paginile site-ului.',
        ],
      },
      {
        title: 'Cat timp pastram datele',
        paragraphs: [
          'Mesajele trimise prin formular pot fi pastrate atat timp cat este necesar pentru raspuns, relatie comerciala, evidenta comunicarii sau obligatii legale aplicabile.',
          'Preferintele locale privind limba si cookies raman in browser pana cand le stergi sau le modifici.',
        ],
      },
      {
        title: 'Drepturile tale',
        paragraphs: [
          'In functie de situatia concreta, poti solicita acces, rectificare, stergere, restrictionare, opozitie sau portabilitate, precum si retragerea consimtamantului pentru analytics.',
          'Poti modifica oricand setarile de cookies din footer, iar daca ai o nemultumire privind prelucrarea datelor poti contacta operatorul sau autoritatea competenta.',
        ],
      },
    ],
  },
  en: {
    title: 'Privacy Policy',
    lead:
      'This page explains what personal data may be processed through this website, for what purpose, and how it is handled. The text should be reviewed regularly with the person or advisor responsible for legal compliance.',
    sections: [
      {
        title: 'Controller and contact details',
        paragraphs: [
          'This website is operated by YOUNGER KAROM PRODUCTION COMPANY SRL, tax ID code 4219179, registered with the Trade Register under no. J40/15256/1993. For privacy requests or to exercise your rights, you can contact us at office@youngerkarom.ro or at Strada Paharnicul Turturea 12, Sector 2, Bucharest, Romania.',
        ],
      },
      {
        title: 'What data may be collected',
        paragraphs: [
          'When you use the contact form, we may process your name, company, phone number, email address, and the message you send.',
          'The website also uses strictly necessary technical data for operation, such as language preference and your cookie choice, stored locally in the browser.',
          'Website usage analytics are collected only if you give consent for analytics cookies.',
        ],
      },
      {
        title: 'Legal bases and purposes',
        paragraphs: [
          'Contact form data is used to answer your commercial or technical requests and to continue the conversation you initiated.',
          'Necessary technical storage is used for the proper functioning of the website and to remember your choices.',
          'Optional analytics are used only after consent to understand site usage, improve content, and identify user experience issues.',
        ],
      },
      {
        title: 'Third-party services',
        paragraphs: [
          'Technical service providers may be involved in operating the contact form and processing the data strictly necessary to send your message.',
          'If you accept analytics cookies, a third-party analytics provider may process information about your interaction with the website pages.',
        ],
      },
      {
        title: 'How long data is kept',
        paragraphs: [
          'Messages sent through the form may be kept as long as needed for response handling, commercial relationship, communication records, or applicable legal obligations.',
          'Local language and cookie preferences remain in the browser until you delete or change them.',
        ],
      },
      {
        title: 'Your rights',
        paragraphs: [
          'Depending on the specific situation, you may request access, rectification, erasure, restriction, objection, portability, and withdrawal of consent for analytics.',
          'You can change cookie settings at any time from the footer, and if you have a complaint about data processing you may contact the controller or the competent authority.',
        ],
      },
    ],
  },
};

export default function PrivacyPolicy() {
  const { lang } = useI18n();
  const content = CONTENT[lang] || CONTENT.ro;

  return (
    <section className="yk-page yk-legalPage">
      <header className="yk-card yk-legalCard">
        <h1 className="yk-h1">{content.title}</h1>
        <p className="yk-text">{content.lead}</p>
      </header>

      {content.sections.map((section) => (
        <article key={section.title} className="yk-card yk-legalCard yk-legalSection">
          <h2 className="yk-h2">{section.title}</h2>
          {section.paragraphs.map((paragraph) => (
            <p key={paragraph} className="yk-text">
              {paragraph}
            </p>
          ))}
        </article>
      ))}
    </section>
  );
}